import { useState } from 'react';

interface NamePromptProps {
  onSubmit: (name: string) => void;
  isLoading?: boolean;
  savedName?: string;
}

export const NamePrompt: React.FC<NamePromptProps> = ({
  onSubmit,
  isLoading,
  savedName,
}) => {
  const [name, setName] = useState(savedName || '');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Use provided name or generate anonymous name
    const displayName =
      name.trim() || `Anonymous ${Math.floor(Math.random() * 1000)}`;
    onSubmit(displayName);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          What should we call you?
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name (optional)"
          className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
          maxLength={30}
          autoFocus
          disabled={isLoading}
        />
        <p className="text-xs text-gray-400 mt-1">
          Leave blank to join anonymously
        </p>
      </div>
      <button
        type="submit"
        disabled={isLoading}
        className="w-full bg-primary-600 text-white py-3 rounded-xl font-semibold disabled:opacity-50 hover:bg-primary-700 transition"
      >
        {isLoading ? 'Joining...' : 'Join Story'}
      </button>
    </form>
  );
};
